<template>
  <div>
    <component :is="layout"/>
  </div>
</template>
<script>
import InProgress from "@/components/InProgress";
// import zayavkaKcpStructureOrg from "@/pages/zayvkaKcp/zayavkaKcpStructureOrg.vue"
// import zayavkaKcpStructureFounder from "@/pages/zayvkaKcp/zayavkaKcpStructureFounder"
import founderStageThree from "@/views/private/stages/founderStageThree";
import {mapGetters} from "vuex"
export default {
  name: 'respresStages3',
  components: {
    InProgress,
    // zayavkaKcpStructureOrg,
    // zayavkaKcpStructureFounder,
    founderStageThree
  },
  computed: {
    ...mapGetters('auth', {get_replace_role_id_admin:'get_replace_role_id_admin'}),
    layout() {
      let nameComponent = 'zayavkaKcpStructureOrg'
      switch (this.get_replace_role_id_admin){
        // case 1:
        //   nameComponent = 'zayavkaKcpStructureOrg'
        //   break
        case 4:
          nameComponent = 'founderStageThree'
          break
        default:
          nameComponent = 'InProgress'
          break
      }
      return nameComponent;
    }
  },
}

</script>